import { blockInfo } from '../../../blockInfo';
import { count } from '../../../count';
import { JourneyDraft } from '../../../draft';
import { DeleteTarget, locate } from '../../../selection';
import JourneyConfirmModal from '../../JourneyConfirmModal/JourneyConfirmModal';

interface DeleteNodeModalProps {
  draft: JourneyDraft;
  target?: DeleteTarget;
  onConfirm: () => void;
  onClose: () => void;
}

const DeleteNodeModal = ({ draft, target, onConfirm, onClose }: DeleteNodeModalProps) => {
  const location = target && locate(draft, target);
  if (!target || !location) return null;

  const { mileIndex, stepIndex, blockIndex } = location;
  const mile = draft.miles[mileIndex];
  const step = mile.steps[stepIndex];

  const renderContent = () => {
    if (target.kind === 'mile') {
      const blocksCount = mile.steps.reduce((sum, s) => sum + s.blocks.length, 0);
      return {
        title: `Delete Mile ${mileIndex + 1}?`,
        message: (
          <>
            <b>{mile.title || 'Untitled mile'}</b>, its {count(mile.steps.length, 'step')} and{' '}
            {count(blocksCount, 'block')} and its Mile complete screen will be deleted. Miles after
            it move up a number.
          </>
        ),
      };
    }

    if (target.kind === 'step') {
      return {
        title: `Delete Step ${mileIndex + 1}.${stepIndex + 1}?`,
        message: (
          <>
            <b>{step.title || 'Untitled step'}</b> and its {count(step.blocks.length, 'block')} will
            be deleted. Steps after it move up a number.
          </>
        ),
      };
    }

    const block = step.blocks[blockIndex];
    const { title, typeLabel } = blockInfo(block);
    return {
      title: 'Delete block?',
      message: block.checkIn ? (
        <>
          <b>{title}</b> ({typeLabel}) and its content will be deleted.
        </>
      ) : (
        <>
          <b>{title}</b> ({typeLabel}) will be removed from this step. It stays in Explore.
        </>
      ),
    };
  };

  const { title, message } = renderContent();

  return (
    <JourneyConfirmModal
      isOpen
      title={title}
      confirmLabel="Delete"
      danger
      onConfirm={onConfirm}
      onClose={onClose}
    >
      {message}
    </JourneyConfirmModal>
  );
};

export default DeleteNodeModal;
